export enum RelationshipFilterOptions {
  All = "all",
  Parent = "parent",
  Child = "child",
  NonGrouped = "non grouped"
}
